<template>
  <CosFixFooterPage :autoFooter="selectData.target !== 'dayOffSetting'">
    <div class="rule-manage-box">
      <div class="title">{{ selectData.title }}</div>
      <div v-if="selectData.target === 'saleCue'" class="msg-box">
        <p>
          每个用户，每天最多领取<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_1[0]"
            placeholder="请输入"
          />条销售线索
        </p>
        <p>
          线索领取后，<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_2[0]"
            placeholder="请输入"
          />个工作日内未填写<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_2[1]"
            placeholder="请输入"
          />条跟进记录，系统自动将线索退回到公共线索池，并且同一销售无法对该线索进行二次认领；
          线索退回到公共线索池前<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.CLUE_RULE_2[2]"
            placeholder="请输入"
          />个工作日通过飞书提醒客户负责人；
        </p>
        <p>置为【未来线索】后，<a-input-number
          class="input"
          :precision="0"
          :min="1"
          v-model:value="saleFormState.CLUE_RULE_4[0]"
          placeholder="请输入"
        />天后未变为跟进中，则自动进入公海池；</p>
        <p>置为【无效线索】后，<a-input-number
          class="input"
          :precision="0"
          :min="1"
          v-model:value="saleFormState.CLUE_RULE_5[0]"
          placeholder="请输入"
        />天后未变为跟进中，则自动进入公海池。</p>
        <!-- <p>
        置为【无效线索】后，<a-input-number
          class="input"
          :precision="0"
:min="1"
          v-model:value="saleFormState.CLUE_RULE_3[0]"
          placeholder="请输入"
        />天后未变为有效线索，则自动进入公海池。
      </p> -->
      </div>
      <div v-if="selectData.target === 'potentialCustomer'" class="msg-box">
        <div class="subTitle">谈判</div>

        <p>
          状态潜在客户,在距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.POTENTIAL_RULE_1[0]"
            placeholder="请输入"
          />个工作日后还没有再次跟进，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
        <div class="subTitle">已注册</div>

        <p>
          状态潜在客户,在距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.POTENTIAL_RULE_2[0]"
            placeholder="请输入"
          />个工作日后还没有再次跟进，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
        <div class="subTitle">无合作可能</div>

        <p>
          状态潜在客户,在距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.POTENTIAL_RULE_3[0]"
            placeholder="请输入"
          />个工作日后还没有再次跟进，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
      </div>

      <div v-if="selectData.target === 'successCustomer'" class="msg-box">
        <p>
          除【流失】状态外，在距离最后一次跟进记录<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.DEAL_RULE_1[0]"
            placeholder="请输入"
          />个工作日后还没有再次跟进，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。
        </p>
      </div>
      <div v-if="selectData.target === 'appSignSetting'" class="msg-box">
        <p>
          签到列表，展示自身定位<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGN_IN_RULE_1[0]"
            placeholder="请输入"
          />米范围内的客户信息。（仅能在范围内签到）
        </p>
        <p>
          签到打卡后，在上次签到范围内<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGN_IN_RULE_2[0]"
            placeholder="请输入"
          />分钟后才能第二次打卡签到；同一个客户<a-input-number
            class="input"
            :precision="0"
            :min="1"
            v-model:value="saleFormState.SIGN_IN_RULE_2[1]"
            placeholder="请输入"
          />分钟后才能第二次打卡签到。
        </p>
      </div>
      <div v-if="selectData.target === 'businessSetting'" class="msg-box">
        <template v-for="item in businessSettingList" :key="item.key">
          <div class="subTitle">{{ item.label }}</div>
          <p>
            在商机距离最后一次变更状态<a-input-number
              class="input"
              :precision="0"
              :min="1"
              v-model:value="saleFormState[item.key][0]"
              placeholder="请输入"
            />个工作日后还没有再次变更其他状态，通过第三方（飞书）、系统弹窗提醒商机负责人跟进，超时仍未跟进标记【超时】。
          </p>
        </template>
      </div>
      <div v-if="selectData.target === 'clueCreateSetting'" class="msg-box">
        <p>
          线索自动创建后默认的线索负责人
          <UserSelect
            v-model:value="saleFormState.CLUE_DEFAULT_EMPLOYEE"
            style="width: 250px"
            placeholder="请选择客户负责人"
            allowClear
          />
        </p>
      </div>
    </div>
    <template #footer>
      <div class="footer-box" v-if="selectData.target !== 'dayOffSetting'">
        <a-button type="primary" @click="handleSubmit">保存</a-button>
      </div>
    </template>
    <div v-if="selectData.target === 'dayOffSetting'">
      <DayOffCalendar :typePage="'cos_lbu'"></DayOffCalendar>
    </div>
  </CosFixFooterPage>
</template>

<script lang="ts">
import { defineComponent, reactive, PropType, toRefs, onMounted } from 'vue'
import type { IndexEchart } from '@/types/index'
import DayOffCalendar from '@/components/DayOffCalendar/index.vue'
import { infoData, updateData } from '@/api/gucangSales/followRuleSetting'
import { DcMessage } from '@dc-platform/dc-components'
import CosFixFooterPage from '@/components/CosFullLayout/fixFooterPage.vue'

export default defineComponent({
  props: {
    data: {
      type: Object as PropType<IndexEchart.RuleManageList>,
      default: () => ({})
    }
  },
  components: { DayOffCalendar, CosFixFooterPage },
  setup(props) {
    const selectData = toRefs(props).data
    const saleFormState = reactive<any>({
      CLUE_RULE_1: [0],
      CLUE_RULE_2: [0, 0, 0],
      CLUE_RULE_3: [0],
      CLUE_RULE_4: [0],
      CLUE_RULE_5: [0],
      POTENTIAL_RULE_1: [0],
      POTENTIAL_RULE_2: [0],
      POTENTIAL_RULE_3: [0],
      DEAL_RULE_1: [0],
      SIGN_IN_RULE_1: [0],
      SIGN_IN_RULE_2: [0, 1],
      SALE_CHANCE_FOLLOW_RULE_1: [0],
      SALE_CHANCE_FOLLOW_RULE_2: [0],
      SALE_CHANCE_FOLLOW_RULE_3: [0],
      SALE_CHANCE_FOLLOW_RULE_4: [0],
      SALE_CHANCE_FOLLOW_RULE_5: [0],
      SALE_CHANCE_FOLLOW_RULE_6: [0]
    })
    const businessSettingList = [
      {
        label: '01-潜力商机',
        key: 'SALE_CHANCE_FOLLOW_RULE_1'
      },
      {
        label: '02-首次接触',
        key: 'SALE_CHANCE_FOLLOW_RULE_2'
      },
      {
        label: '03-提供方案&谈判',
        key: 'SALE_CHANCE_FOLLOW_RULE_3'
      },
      // {
      //   label: '签约',
      //   key: 'SALE_CHANCE_FOLLOW_RULE_4'
      // },
      {
        label: '04-签约&准备发件',
        key: 'SALE_CHANCE_FOLLOW_RULE_5'
      },
      {
        label: '05-首次发件',
        key: 'SALE_CHANCE_FOLLOW_RULE_6'
      }
    ]
    const getData = async () => {
      try {
        const res = await infoData({ appId: 'cos_lbu', configType: 3 })
        const allData: any = res.data
        Reflect.ownKeys(allData).forEach(function (key) {
          saleFormState[key] = allData[key].split(',')
        })
        console.log('res: ', res)
      } catch (error) {
        console.log('error: ', error)
      }
    }
    const handleSubmit = async () => {
      try {
        const submitData: any = {}

        Reflect.ownKeys(saleFormState).forEach(function (key) {
          submitData[key] = Array.isArray(saleFormState[key]) ? saleFormState[key].join() : saleFormState[key]
        })
        await updateData({
          appId: 'cos_lbu',
          logic: submitData
        })
        DcMessage.success('保存成功！')
        getData()
      } catch (error) {
        console.log('handleSubmit error: ', error)
      }
    }
    onMounted(() => {
      getData()
    })
    return {
      selectData,
      saleFormState,
      businessSettingList,
      handleSubmit
    }
  }
})
</script>
<style lang="scss" scoped>
.rule-manage-box {
  padding: 16px 16px 0;

  .title {
    font-weight: 500;
    font-size: 16px;
    color: #132043;
    padding-left: 8px;
    position: relative;
    margin-bottom: 12px;
  }
  .title::after {
    width: 2px;
    height: 20px;
    background-color: #1d4cd2;
    position: absolute;
    left: 0;
    top: 3px;
    content: '';
  }
  .input {
    width: 80px;
    display: inline-block;
    margin: 0 5px;
  }
  .subTitle {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    height: 40px;
    display: flex;
    align-items: center;
    margin: 25px 20px 16px;
    border-bottom: 1px solid rgb(235, 239, 241);
  }
  p {
    padding-left: 20px;
    margin-bottom: 10px;
  }
  .footer-box {
    width: 100%;
    height: 64px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .line-bg {
    width: 100%;
    height: 8px;
    background-color: rgb(249, 249, 255);
    padding: 0 16px;
    box-sizing: content-box;
    position: relative;
    left: -16px;
  }
}
.msg-box {
  height: 67vh;
}
</style>
